import fromEntries from '../object/fromEntries';

export default function filterOutCurrentLocaleRoutes(
  routesByLocale,
  currentLocale,
) {
  return fromEntries(
    Object
      .entries(routesByLocale)
      .filter(([pageLocale]) => pageLocale !== currentLocale),
  );
}
